import { useState } from "react";
import RolesList from "../components/roles/RolesList";
import PermissionMatrix from "../components/permissions/PermissionMatrix";
import UsersRoleTable from "../components/users/UsersRoleTable";

export default function AccessControlPage() {

  const [activeTab, setActiveTab] = useState("roles");
  const [selectedRoleId, setSelectedRoleId] = useState(null);

  return (
    <div className="ac-page">

      <div className="ac-header">
        <h1>Access Control</h1>
        <p>Manage user roles and permissions</p>
      </div>

      <div className="ac-tabs">
        <button
          className={activeTab === "roles" ? "active" : ""}
          onClick={() => setActiveTab("roles")}
        >
          Role Permissions
        </button>

        <button
          className={activeTab === "users" ? "active" : ""}
          onClick={() => setActiveTab("users")}
        >
          User Roles
        </button>
      </div>

      {activeTab === "roles" && (
        <div className="ac-layout">

          <div className="ac-left">
            <RolesList
              selectedRoleId={selectedRoleId}
              onSelectRole={setSelectedRoleId}
            />
          </div>

          <div className="ac-right">
            <PermissionMatrix roleId={selectedRoleId} />
          </div>

        </div>
      )}

      {activeTab === "users" && (
        <div className="ac-users">
          <UsersRoleTable scopeIdRoles={selectedRoleId} />
        </div>
      )}
<style>{`.ac-page {
  padding: 24px;padding-top:70px;
  font-family: Arial, sans-serif;
}

.ac-header h1 {
  margin: 0;
  font-size: 22px;
}

.ac-header p {
  margin: 4px 0 16px 0;
  color: #666;
  font-size: 14px;
}

.ac-tabs {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
}

.ac-tabs button {
  background: none;
  border: none;
  padding: 8px 0;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}

.ac-tabs button.active {
  border-bottom: 2px solid #1976d2;
  color: #1976d2;
  font-weight: 600;
}

.ac-layout {
  display: flex;
  gap: 20px;
}

.ac-left {
  width: 30%;
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 6px;
}

.ac-right {
  width: 70%;
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 6px;
}

.ac-users {
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 6px;
}`}</style>
    </div>
  );
}